import React from 'react'
import breakpoint from 'tools/styled-components-breakpoint'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { borderRadius, borderRadiusSizes, colors, margin, marginSizes } from 'theme/default'
import Div from 'components/Div'
import Flex from 'components/Flex'
import Modal from 'components/Modal'
import { H1, H4, P } from 'components/Typo'
import Button from 'components/Button'

const Container = styled(Div)`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  height: auto;
  transform: translateX(-50%) translateY(-50%);
  overflow: hidden;
  padding: 0;
  background: ${props => props.theme.colorContainerColor};
  border-radius: ${borderRadius[borderRadiusSizes.medium]};
  ${breakpoint('desktop')`
    max-width: 500px;
  `}
`
Container.defaultProps = {
  theme: {
    colorContainerColor: colors.container
  }
}

const InnerContainer = styled(Flex).attrs(() => ({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}))`
  height: 100%;
  margin: ${margin[marginSizes.largeSize]} ${margin[marginSizes.medium]};
  ${breakpoint('desktop')`
    margin: ${margin[marginSizes.extraLarge]} ${margin[marginSizes.medium]};
  `}
`

const ButtonsContainer = styled(Flex).attrs(() => ({
  alignSelf: 'stretch',
  justifyContent: 'space-between'
}))`
  width: 100%;
  max-width: 410px;
  margin: 0 auto;
`

const DialogButton = styled(Button)`
  width: 40%;
  margin: 0 auto;
`

class Dialog extends React.PureComponent {
  static propTypes = {
    show: PropTypes.bool,
    header: PropTypes.any,
    body: PropTypes.any,
    onClose: PropTypes.func,
    buttons: PropTypes.any,
    onClosed: PropTypes.func,
    subText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    slideInAnimation: PropTypes.string,
    footer: PropTypes.element,
    closeOnBackdropClick: PropTypes.bool,
    closeOnEscapeKeyPress: PropTypes.bool,
    initialFocus: PropTypes.string,
    Backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.symbol, PropTypes.element])
  }

  static defaultProps = {
    show: false,
    onClose: x => x,
    slideInAnimation: 'top',
    footer: null
  }

  render () {
    const { initialFocus, header, body, subText, buttons, show, onClose, onClosed, slideInAnimation, closeOnBackdropClick, closeOnEscapeKeyPress, footer, Backdrop } = this.props

    return (
      <Modal slideInAnimation={slideInAnimation} show={show} onClose={onClose} onClosed={onClosed} closeOnBackdropClick={closeOnBackdropClick} closeOnEscapeKeyPress={closeOnEscapeKeyPress} initialFocus={initialFocus} Backdrop={Backdrop}>
        <Container>
          <InnerContainer>
            <H1 bold textAlign='center' marginTop={marginSizes.none} marginBottom={marginSizes.none}>{header}</H1>
            <H4 marginTop={marginSizes.small} marginBottom={subText ? marginSizes.small : marginSizes.large} textAlign='center'>{body}</H4>
            {subText && (<P normalised marginBottom={marginSizes.medium}>{subText}</P>)}
            <ButtonsContainer>
              {buttons}
            </ButtonsContainer>
            {footer}
          </InnerContainer>
        </Container>
      </Modal>
    )
  }
}

Dialog.Button = DialogButton

export default Dialog
